import { render } from "./ColumnMappingProposalModal.vue?vue&type=template&id=27f3fabe"
import script from "./ColumnMappingProposalModal.vue?vue&type=script&lang=js"
export * from "./ColumnMappingProposalModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/components/ColumnMappingProposalModal.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "27f3fabe"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('27f3fabe', __exports__)) {
    api.reload('27f3fabe', __exports__)
  }
  
  module.hot.accept("./ColumnMappingProposalModal.vue?vue&type=template&id=27f3fabe", () => {
    api.rerender('27f3fabe', render)
  })

}


export default __exports__